import React, { type JSX } from 'react';
import { LoadLists } from './LoadLists';
import { ManageLoadGroups } from './ManageLoadGroups';
import { Paper } from '@mui/material';
import { FailedLoadTriggerModal } from 'components';
import { useTypedSelector, useAppDispatch } from '@fiji/common';
import { closeMqttConnection, connectMQTT } from '@fiji/common/src/mqtt_connection/mqttConnection';
import { useGetUserProfileQuery } from '@fiji/common/src/features/profile/profileApi';
import { ApiEndpointType, ApiResponseType } from '@fiji/common/src/features/common/commonTypes';
import { UserProfile } from '@fiji/common/src/types';
import {
    setIsLoadRefresh,
    setMqttConnectionStatus,
    setMqttCredentials,
} from '@fiji/common/src/features/common/commonSlice';
import { useGetMQTTCredentialsQuery } from '@fiji/common/src/features/mqtt/mqttApi';
import { decryptAES } from 'utils/helpers';

export const LoadsGroupsDetails = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const mqttConnectionStatus = useTypedSelector((state) => state['common']['mqttConnectionStatus']);
    const mqttCredentials = useTypedSelector((state) => state['common']['mqttCredentials']);
    const { data: mqttEncryptedData }: any = useGetMQTTCredentialsQuery();
    const { data: profileData } = useGetUserProfileQuery({}, { refetchOnMountOrArgChange: true }) as ApiEndpointType<
        ApiResponseType<UserProfile>
    >;

    React.useEffect(() => {
        if (mqttEncryptedData?.data && profileData) {
            const decryptedCredentials = decryptAES(mqttEncryptedData?.data, {
                userId: profileData?.data?.id,
                requestId: mqttEncryptedData?.requestId,
            });

            if (decryptedCredentials?.hostname !== window.APP_CONFIG.API_URL?.replace('https://', '')) {
                decryptedCredentials['hostname'] = window.APP_CONFIG.API_URL?.replace('https://', '');
            }
            dispatch(setMqttCredentials({ ...decryptedCredentials }));
        }
    }, [mqttEncryptedData, profileData]);

    React.useEffect(() => {
        if (
            mqttCredentials &&
            Object.keys(mqttCredentials)?.length &&
            (mqttConnectionStatus === false ||
                mqttConnectionStatus === 'closed-device' ||
                mqttConnectionStatus === 'closed-group')
        ) {
            dispatch(setMqttConnectionStatus('loading'));
            connectMQTT(
                () => {
                    dispatch(setMqttConnectionStatus(true));
                },
                {
                    ...mqttCredentials,
                    protocol: 'wss',
                }
            );
        }
    }, [mqttCredentials, mqttConnectionStatus]);

    React.useEffect(
        () => () => {
            closeMqttConnection();
            dispatch(setMqttConnectionStatus(false));
            dispatch(setIsLoadRefresh(false));
        },
        []
    );

    return (
        <>
            <Paper elevation={0} sx={{ background: '#F3F5F5' }}>
                <ManageLoadGroups />
                <LoadLists />
            </Paper>
            <FailedLoadTriggerModal
                onClose={() => {
                    dispatch(setIsLoadRefresh(true));
                }}
            />
        </>
    );
};
